import React from 'react'
import PropTypes from 'prop-types'
import { useDeleteMemberMutation, useInviteMemberMutation } from '../store/rosterApi'
import { showErrorNotification } from 'Shared/helpers'

const t = (key) => (!window.I18n ? key : window.I18n.t(key))

const STATUS_I18N_KEYS = {
  registered:   'customer_groups.groups.members.status.registered',
  invited:      'customer_groups.groups.members.status.invited',
  unregistered: 'customer_groups.groups.members.status.unregistered',
  no_email:     'customer_groups.groups.members.status.no_email',
}

const inviteLabel = (status) => {
  if (status === 'invited') return t('customer_groups.groups.members.actions.resend_invitation')
  if (status === 'unregistered') return t('customer_groups.groups.members.actions.send_invitation')
  return null
}

const RowActionsDropdown = ({ member, onEditMember }) => {
  const inviteText = inviteLabel(member.status)
  const [deleteMember] = useDeleteMemberMutation()
  const [inviteMember] = useInviteMemberMutation()

  const handleDelete = async (e) => {
    e.preventDefault()
    if (!window.confirm(t('customer_groups.groups.members.actions.delete_confirm'))) return
    try {
      await deleteMember({ memberId: member.id }).unwrap()
    } catch (error) {
      showErrorNotification(error?.error || error?.message || t('customer_groups.groups.members.actions.delete_error'))
    }
  }

  const handleInvite = async (e) => {
    e.preventDefault()
    try {
      await inviteMember({ memberId: member.id }).unwrap()
    } catch (error) {
      showErrorNotification(error?.error || error?.message || t('customer_groups.groups.members.actions.invite_error'))
    }
  }

  return (
    <div className='btn-group'>
      <button
        type='button'
        className='btn btn-xs btn-default dropdown-toggle roster-row-actions-btn'
        data-toggle='dropdown'
        aria-haspopup='true'
        aria-expanded='false'
        aria-label={t('customer_groups.groups.members.actions.row_menu')}
      >
        <i className='fa fa-ellipsis-v' aria-hidden='true' />
      </button>
      <ul className='dropdown-menu dropdown-menu-right'>
        <li>
          <a href='#' onClick={(e) => { e.preventDefault(); onEditMember(member) }}>
            <i className='fa-solid fa-pen' />
            {t('customer_groups.groups.members.actions.edit')}
          </a>
        </li>
        {inviteText && (
          <li>
            <a href='#' onClick={handleInvite}>
              <i className='fa-regular fa-envelope' />
              {inviteText}
            </a>
          </li>
        )}
        <li>
          <a href='#' className='text-danger' onClick={handleDelete}>
            <i className='fa-regular fa-trash-can' />
            {t('customer_groups.groups.members.actions.delete')}
          </a>
        </li>
      </ul>
    </div>
  )
}

RowActionsDropdown.propTypes = {
  member:       PropTypes.object.isRequired,
  onEditMember: PropTypes.func.isRequired,
}

const RosterTableRow = ({ member, onEditMember, phoneFieldName }) => (
  <tr>
    <td>
      {member.handle
        ? <button type='button' className='roster-handle-link' onClick={() => onEditMember(member)}>{member.handle}</button>
        : '-'
      }
    </td>
    {[ 'first_name', 'last_name', 'gender', 'email', 'ghin' ].map((key) => <td key={key}>{member[key] || '-'}</td>)}
    {phoneFieldName && <td>{member.phone || '-'}</td>}
    <td>{member.usga_index || '-'}</td>
    <td>
      <span className={`group-leader-status-badge group-leader-status-badge--${member.status.replace(/_/g, '-')}`}>
        {STATUS_I18N_KEYS[member.status] ? t(STATUS_I18N_KEYS[member.status]) : member.status}
      </span>
    </td>
    <td className='text-center'>
      <RowActionsDropdown member={member} onEditMember={onEditMember} />
    </td>
  </tr>
)

RosterTableRow.propTypes = {
  member: PropTypes.shape({
    id:          PropTypes.string.isRequired,
    handle:      PropTypes.string,
    first_name:  PropTypes.string,
    last_name:   PropTypes.string,
    gender:      PropTypes.string,
    email:       PropTypes.string,
    ghin:        PropTypes.string,
    phone:       PropTypes.string,
    usga_index:  PropTypes.string,
    status:      PropTypes.string.isRequired,
  }).isRequired,
  onEditMember:  PropTypes.func.isRequired,
  phoneFieldName: PropTypes.string,
}

export default RosterTableRow
